function init() {
    const animationItems = document.querySelectorAll(".animated-media, .where-to-buy");
    if (animationItems.length > 0) {
        import("@lottiefiles/lottie-player")
    }
}

export default { init };